import { WithStyles, withStyles } from '@mui/styles';
import { UserAccountMapped } from '@tassat/fred-extended-definitions';
import { WalletTotalBalanceTileStats } from '@tassat/text/src/WalletTotalBalanceTile/types';

import { muiStyles } from './styles';
import { WalletDetails } from './walletDetails';

export interface WalletDetailsProps extends WithStyles<typeof muiStyles> {
    userAccountMapped: UserAccountMapped;
    accountPositionStats: WalletTotalBalanceTileStats[];
    linkedBDAccountId: string;
}

export default withStyles(muiStyles)(WalletDetails);